import { clientShopId } from 'config/const';
import {
  accessTokenHeader,
  callTpFetch,
  idTokenHeader,
  tokenHeader,
} from './utils';

const EndPoint = {
  GetCarts: (lineId) =>
    `/linewebhook/customer/shop/${clientShopId}/${lineId}/carts`,
  UpdateCart: (lineId) => `/linewebhook/cart/shop/${clientShopId}/${lineId}`,
  ReplaceCart: (lineId) => `/linewebhook/cart/shop/${clientShopId}/${lineId}`,
};

export function getCarts(lineId, accessToken, idToken) {
  const uri = EndPoint.GetCarts(lineId);
  let settings = {
    method: 'GET',
    headers: {
      ...accessTokenHeader(accessToken),
      ...idTokenHeader(idToken),
      ...tokenHeader,
    },
  };

  return callTpFetch(uri, settings);
}

export function updateCart(lineId, idToken, carts = {}) {
  const uri = EndPoint.UpdateCart(lineId);
  let settings = {
    method: 'PATCH',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    body: JSON.stringify(carts),
  };

  return callTpFetch(uri, settings);
}

export function replaceCart(lineId, idToken, item = []) {
  const uri = EndPoint.ReplaceCart(lineId);
  let settings = {
    method: 'PUT',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    body: JSON.stringify(item),
  };

  return callTpFetch(uri, settings);
}
